import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { pushUnsubscribeModal } from '../../Tier/redux/consumer/actions';
import {
  isConsumerReduxReady,
  isMatureFilterOverridden,
} from '../../Tier/redux/consumer/selectors';
import { Props } from './SubscribeButton';

export type StateProps = Pick<Props, 'reduxReady' | 'matureFilterOverridden'>;
export type DispatchProps = Pick<Props, 'onUnsubscribe'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (state, ownProps) => ({
  reduxReady: isConsumerReduxReady(state),
  matureFilterOverridden: isMatureFilterOverridden(state, ownProps.tier.deviationId),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onUnsubscribe: pushUnsubscribeModal,
};

export default connect(mapStateToProps, mapDispatchToProps);
